<script setup lang="ts">
import { onMounted, computed } from 'vue'
import ReferralBanner from '@/components/Referrals/Banner/index.vue'
import type { ReferralBannerHandlerComponentModule } from '@/components/Referrals/BannerHandler/types'
import { getReferralBonus } from '@/utils/referralBonus'
const { t, locale } = useI18n()

const bonus = computed(() => getReferralBonus(locale.value, false))
const bonusWithCurrency = computed(() => getReferralBonus(locale.value, true))
const props = withDefaults(defineProps<ReferralBannerHandlerComponentModule.Props>(), {
  dataAttributes: {
    dataLh: { P: 'unknown', Z: 'unknown' }
  }
})

const { experimentVersion, initExperiment } = useABTest(props.abTestingKey)

onMounted(() => {
  initExperiment()
})
</script>

<script lang="ts">
export default {
  name: 'ReferralBannerHandler'
}
</script>

<template>
  <ReferralBanner
    :id="abTestingKey"
    :title="t(`${experimentVersion}.title.part1`)"
    :subtitle="t(`${experimentVersion}.title.part2`, { bonus, bonusWithCurrency })"
    :subtitle-2="t(`${experimentVersion}.title.part3`)"
    :description="t(`${experimentVersion}.description`, { bonusWithCurrency })"
    :submit-button-text="t(`${experimentVersion}.registerNow`)"
    :data-attributes="dataAttributes"
    :submit-button-url="`${t(`${experimentVersion}.registerUrl`)}?utm_source=${sourcePage}&utm_medium=web`" />
</template>

<i18n src="./i18n.json" type="json" />
